import { Component, Input, ViewChild, Output, OnDestroy, EventEmitter, OnInit } from '@angular/core';
import { RoleService}                                                           from '../../services/role.service';
import { Role }                                                                 from '../../models/role';
import { ModalDirective }                                                       from 'ng2-bootstrap/modal';
import { Router }                                                               from '@angular/router';
import { Location }                                                             from '@angular/common';
import { Subject }                                                              from 'rxjs/Subject';
import 'rxjs/add/operator/switchMap';

@Component({
  selector: 'role-add',
  templateUrl: 'role-add.component.html',
  styleUrls: ["role-add.component.scss"]
})

export class RoleAddComponent implements OnInit, OnDestroy {
  id: string;
  name: string;

  @Output() roleAdded = new EventEmitter();
  @ViewChild('myModal') modal:ModalDirective;

  private role = new Role();
  private ngUnsubscribe: Subject<void> = new Subject<void>();

  constructor(
    private RoleService: RoleService,
    private router: Router
  ) { }

  ngOnInit(): void {}

  ngOnDestroy() {
      this.ngUnsubscribe.next();
      this.ngUnsubscribe.complete();
  }

  show(): void {
      this.modal.show();
  }

  add(role): void {
    this
      .RoleService
      .create(role)
      .subscribe(role => {
        this.roleAdded.emit(role);
        this.modal.hide();
      });
  }

  close(role): void {
      this.modal.hide();
  }
}



// WEBPACK FOOTER //
// ./src/app/users/components/role-add/role-add.component.ts